// @team Growth Leads

import type { ComponentProps } from 'react';
import type { WorkbenchProvider } from '@gusto/workbench';

type PartnerTheme = NonNullable<ComponentProps<typeof WorkbenchProvider>['theme']>;

const partnerWorkbenchTheme: PartnerTheme = {
  colors: {
    salt: {
      100: '#ffffff',
      200: '#fbfafa',
      300: '#f4f4f3',
      500: '#dcdcdc',
      900: '#525257',
      1000: '#1c1c1c',
    },
    kale: {
      200: '#e0f2f5',
      400: '#2babad',
      500: '#0a8080',
      800: '#005961',
    },
    error: {
      500: '#d5351f',
    },
  },
};

export default partnerWorkbenchTheme;
